<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import DefaultLayout from './layouts/DefaultLayout.vue'
import { NMessageProvider } from 'naive-ui'
import { getCurrentUser, isAuthenticated, currentUser } from '@/services/auth'
import { hasLanguagePreference, savePreferredLanguage, getLocaleFromPreferred } from '@/services/language'
import LanguageSelectionModal from './components/LanguageSelectionModal.vue'

const showLanguageModal = ref(false)
const { locale } = useI18n()

onMounted(async () => {
  if (!hasLanguagePreference()) {
    showLanguageModal.value = true;
  } else {
    // Set initial locale based on user preference
    const preferredLanguage = localStorage.getItem('preferredLanguage') || 'english';
    locale.value = getLocaleFromPreferred(preferredLanguage);
  }

  if (isAuthenticated.value) {
    await getCurrentUser()
  }

  // Listen for language changes
  window.addEventListener('language-changed', handleLanguageChange)
})

const handleLanguageChange = (event) => {

  // Get the new language from the event
  const newLanguage = event.detail.language || 'english';

  // Update the i18n locale
  locale.value = getLocaleFromPreferred(newLanguage);

  // Dispatch a custom event with more details for components to use
  window.dispatchEvent(new CustomEvent('app-language-updated', {
    detail: { language: newLanguage }
  }));
}

const handleLanguageSelected = (language) => {
  savePreferredLanguage(language);
  showLanguageModal.value = false;
}

// Clean up event listener
onUnmounted(() => {
  window.removeEventListener('language-changed', handleLanguageChange)
})
</script>

<template>
  <NMessageProvider>
    <DefaultLayout>
      <router-view />
      <LanguageSelectionModal v-model:show="showLanguageModal" @language-selected="handleLanguageSelected" />
    </DefaultLayout>
  </NMessageProvider>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>